import { DocsItem } from "@academy/components"

export const SHIPPING_RETURNS_POLICY: DocsItem[] = [
  {
    title: "",
    content: [
      "Thank you for choosing KidsCrafts.shop, a marketplace where children can sell their handmade crafts, and buyers can purchase them. Please read the following Shipping & Returns policy to understand how shipping and returns are handled on our platform.",
    ],
  },
  {
    title: "Shipping",
    content: [],
  },
  {
    title: "1. Shipping Responsibility:",
    content: [
      "1.1. As a seller on KidsCrafts.shop, you are responsible for shipping the products to the buyers. It is your duty to ensure timely and secure delivery of the purchased items.",
      "1.2. You should clearly specify the shipping methods and estimated delivery times in your product listings.",
      "1.3. It is recommended to use reliable shipping providers and provide tracking information to the buyers whenever possible.",
    ],
  },
  {
    title: "2. Shipping Charges",
    content: [
      "2.1. As a seller, you have the discretion to set the shipping charges for your products.",
      "2.2. Clearly communicate the shipping costs to the buyers upfront, either as a fixed amount or based on the buyer's location.",
      "2.3. If you offer free shipping, make sure it is clearly stated in your product listings.",
    ],
  },
  {
    title: "3. Shipping Delays:",
    content: [
      "3.1. In case of any unforeseen circumstances or shipping delays, promptly communicate with the buyer and provide updates on the expected delivery timeframe.",
      "3.2. If the buyer agrees to wait for the delayed shipment, it is your responsibility to fulfill the order as soon as possible.",
    ],
  },
  {
    title: "Returns",
    content: [],
  },
  {
    title: "1. Return Eligibility:",
    content: [
      "1.1. Buyers may request returns if the purchased item is significantly different from the description provided by the seller.",
      "1.2. You should accurately represent your products and provide detailed descriptions, including size, materials used, and any unique characteristics.",
      "1.3. Buyers may also request returns if the item is damaged during shipping or if it arrives in a defective condition.",
    ],
  },
  {
    title: "2. Return Process:",
    content: [
      "2.1. As a seller, you are responsible for handling return requests and resolving any issues directly with the buyer.",
      "2.2. Promptly respond to return requests and work towards a satisfactory resolution.",
      "2.3. If a return is agreed upon, provide instructions to the buyer on how and where to return the item.",
      "2.4. Once you receive the returned item, inspect it to ensure it is in the same condition as when it was shipped to the buyer.",
      "2.5. If the return is valid, issue a refund to the buyer's original payment method within a reasonable timeframe.",
    ],
  },
  {
    title: "3. Refunds:",
    content: [
      "3.1. Refunds should be provided in the same currency and through the same payment method as the original transaction.",
      "3.2. Refunds should include the original shipping charges paid by the buyer unless the return is due to an error on the seller's part.",
    ],
  },
  {
    title: "4. Return Shipping Costs:",
    content: [
      "4.1. Unless the return is due to an error on the seller's part or a defective/damaged item, the buyer is responsible for the return shipping costs.",
      "4.2. Clearly communicate this policy to the buyers to avoid any confusion. Please note that as a seller on KidsCrafts.shop, you are responsible for ensuring a positive buying experience for the customers. Prompt communication, accurate product descriptions, and timely shipping are essential in maintaining customer satisfaction.",
      {
        html: `If you have any questions or need assistance, please contact our customer support team at <a class="underline text-primary" href="mailto:support@kidscrafts.shop">support@kidscrafts.shop</a>.`,
      },
      "Thank you for being a part of KidsCrafts.shop. Happy selling!",
    ],
  },
]
